<template>
  <div
    v-if="menuShow"
    class="rMenu"
    ref="menu"
    id="menu"
    @mouseleave="closeMenu"
    :style="{ top: y + 'px', left: x + 'px' }"
  >
    <ul>
      <li v-for="(m, i) in data" :key="i" @click="liClick(m), closeMenu()">
        {{ m.optionName }}
      </li>
    </ul>
  </div>
</template>

<script>
import { getPageSize } from "e6-base-map/utils/map/e6Common.js";
export default {
  name: "rMenu",
  data() {
    return {
      menuShow: false,
      top: 0,
      left: 0,
      data: []
    };
  },
  props: {
    liClick: {
      type: Function,
      default: function() {
        console.log();
      }
    }
  },
  methods: {
    closeMenu() {
      this.menuShow = false;
    },
    openMenu(obj) {
      let wh = getPageSize();
      this.menuShow = true;
      this.y = obj.y - 70 > wh.pageHeight ? wh.pageHeight : obj.y - 70;
      this.x =
        obj.x - 10 + 120 > wh.pageWidth ? wh.pageWidth - 120 : obj.x - 10;
      this.data = obj.data;
    }
  }
};
</script>
<style>
.rMenu {
  position: absolute;
  top: 0;
  background: #fdfdfd;
  border-radius: 5px;
  border: 1px solid #ececec;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  font-size: 12px;
  color: #444;
}
.rMenu ul {
  padding: 5px 0;
  list-style-type: none;
  margin: 0;
}
.rMenu ul li {
  padding: 5px 10px;
  width: 80px;
  line-height: 14px;
}
.rMenu ul li:last-child {
  border-bottom: 0px;
}
.rMenu ul li:hover {
  background: #eef3f8;
  color: rgb(64, 158, 255);
  cursor: pointer;
}
</style>
